import { Component, OnInit } from "@angular/core";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "app/services/core/shared.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'reports',
  templateUrl: './reports.component.html'
})

export class ReportsComponent implements OnInit {

  labName = '';
  cliaNumber = '';
  cliaSchedule = '';
  stateNumber = '';
  labType = '';
  type = 'primary';

  constructor(public reportsService: ReportsService,
    public sharedService: SharedService,
    private authService: AuthService) { };

  ngOnInit(): void {

    this.reportsService.currentTab = 0;

  }

  tabVisible(type: string): boolean {
    let retVal = false;
    let reqRole = '';
    switch (type) {
      case 'licenseCash':
      case 'mailingLabels':
      case 'demographicReport':
        {
          reqRole = 'LabTech,Admin,OfficeAdmin';
          break;
        }
      case 'proficiencyReports':
      case 'surveyReports':
        {
          reqRole = 'LabTech,Admin';
          break;
        }
    }

    let roles = reqRole.split(',');
    if (this.authService.userHasAtLeastOneRole(roles)) {
      retVal = true;
    }
    return retVal;
  }

}
